
import React from 'react';
import ReactDOM from 'react-dom';
import App from "App.js";
import globalData from "data/globalData.json";
import "./assets/_index.scss";

ReactDOM.render(<App />, document.getElementById(globalData.prefixName));
